import React, { useEffect, useRef, useState } from "react";
import { MdClose } from "react-icons/md";
import './UserView.css';
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { API_BASE_URL } from "../../config";

function UserView() {
    const [users, setUsers] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedRoles, setSelectedRoles] = useState({});
    const [isAddModalOpen, setIsAddModalOpen] = useState(false);
    const modalRef = useRef();
    const [formData, setFormData] = useState({}); // Data for add/update customer
    const [passwordShown, setPasswordShown] = useState(false);
    const togglePasswordVisiblity = () => {
        setPasswordShown(passwordShown => !passwordShown);
    };
    // new user add
    const [newUserData, setNewUserData] = useState({
        name: '', email: '', password: '', role: '', // Default role is user
    });


    const handleNewUserInputChange = (event) => {
        const { name, value } = event.target;
        setNewUserData({
            ...newUserData, [name]: value
        });
    };
    // Close modals when clicking outside
    const closeModal = (e, setModalState) => {
        if (modalRef.current && !modalRef.current.contains(e.target)) {
            setModalState(false);
        }
    };
    useEffect(() => {
        document.addEventListener("mousedown", (e) => closeModal(e, setIsAddModalOpen));
        return () => {
            document.removeEventListener("mousedown", closeModal);
        };
    }, []);
    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value.toLowerCase());
    };

    const filteredUsers = users.filter(user =>
        user.name.toLowerCase().includes(searchTerm) ||
        user.email.toLowerCase().includes(searchTerm) ||
        user.role.toLowerCase().includes(searchTerm)
    );

    const createNewUser = async () => {

        const accessToken = localStorage.getItem('accessToken'); // Assuming 'accessToken' is stored in local storage
        try {
            const form = new FormData();
            Object.entries(newUserData).forEach(([key, value]) => {
                if (value) form.append(key, value);
            });
            const response = await fetch(`${API_BASE_URL}/admin/create-user`, {
                method: 'POST', headers: {
                    'Authorization': `Bearer ${accessToken}`,
                }, body: form
            });

            const data = await response.json();
            if (response.ok) {
                alert(data.message);
                setIsAddModalOpen(false); // Close modal on success
                fetchUsers();
                // Optionally clear form or handle further logic
            } else {
                alert(data.detail || 'Failed to create user');
            }
        } catch (error) {
            console.error('Error creating user:', error);
        }
    };

    useEffect(() => {
        fetchUsers();
    }, []);

    const fetchUsers = async () => {
        const accessToken = localStorage.getItem("accessToken");
        try {
            const response = await fetch(`${API_BASE_URL}/admin/get-users`, {
                method: "GET", headers: {
                    "Authorization": `Bearer ${accessToken}`,
                },
            });
            if (response.ok) {
                const data = await response.json();
                // console.log("get-user-data : ",data);
                setUsers(data.map(user => ({
                    ...user,
                    isApproved: user.approval_status === "Approved" || user.approval_status === null,
                    approval_status: user.approval_status === null ? "Added by Admin" : user.approval_status
                })));
            } else {
                const errorData = await response.json();
                console.error("Failed to fetch users:", errorData.detail || "Unknown error");
            }
        } catch (error) {
            console.error("Error fetching users:", error);
        }
    };

    const suspendUser = async (email) => {
        const confirmed = window.confirm("Are you sure you want to Suspend this user?");
        if (!confirmed) {
            return;
        }
        const accessToken = localStorage.getItem("accessToken");
        try {
            const response = await fetch(`${API_BASE_URL}/admin/suspend-user/${email}`, {
                method: "PUT",
                headers: { "Authorization": `Bearer ${accessToken}` },
            });
            if (response.ok) {
                alert("User suspended successfully");
                setUsers(users.map(user => user.email === email ? { ...user, is_active: false } : user));
            } else {
                console.error("Failed to suspend user");
            }
        } catch (error) {
            console.error("Error suspending user:", error);
        }
    };

    const activateUser = async (email) => {
        const accessToken = localStorage.getItem("accessToken");
        try {
            const response = await fetch(`${API_BASE_URL}/admin/activate-user/${email}`, {
                method: "PUT",
                headers: { "Authorization": `Bearer ${accessToken}` },
            });
            if (response.ok) {
                alert("User activated successfully");
                setUsers(users.map(user => user.email === email ? { ...user, is_active: true } : user));
            } else {
                console.error("Failed to activate user");
            }
        } catch (error) {
            console.error("Error activating user:", error);
        }
    };

    const updateUserRole = async (email, role) => {
        const confirmed = window.confirm("Are you sure you want to Update this User Role?");
        if (!confirmed) {
            return;
        }
        const accessToken = localStorage.getItem("accessToken");
        try {
            const response = await fetch(`${API_BASE_URL}/admin/update-user-role`, {
                method: "PUT",
                headers: {
                    "Authorization": `Bearer ${accessToken}`,
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ new_role: role, email })
            });
            if (response.ok) {
                alert("User role updated successfully");
                setUsers(users.map(user => user.email === email ? { ...user, role } : user));
            } else {
                console.error("Failed to update user role");
            }
        } catch (error) {
            console.error("Error updating user role:", error);
        }
    };

    const handleRoleChange = (email, role) => {
        setSelectedRoles(prev => ({ ...prev, [email]: role }));
    };

    const deleteUser = async (email) => {
        const confirmed = window.confirm("Are you sure you want to delete this user?");
        if (!confirmed) {
            return;
        }
        const accessToken = localStorage.getItem("accessToken");
        try {
            const response = await fetch(`${API_BASE_URL}/admin/delete-user/${email}`, {
                method: "DELETE", headers: {
                    "Authorization": `Bearer ${accessToken}`,
                }
            })
                ;

            if (response.ok) {
                const data = await response.json();
                alert(data.detail);
                setUsers(users.filter(user => user.email !== email));
            } else {
                const errorData = await response.json();
                console.error("Failed to delete user:", errorData.detail || "Unknown error");
            }
        } catch (error) {
            console.error("Error deleting user:", error);
        }
    };

    return (
        <>
            <div className="container mx-auto px-6 py-12">
                <h1 className="text-3xl font-semibold text-center text-gray-800 mb-8">Edumonics Users</h1>
                <div className="flex justify-center mb-6">
                    <input
                        type="text"
                        placeholder="Search by Name, Email, or Role..."
                        className="w-1/2 p-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-yellow-500"
                        onChange={handleSearchChange}
                    />
                </div>
                {/* Button container */}
                <div className="button-container">
                    <button className="action-btn add-btn" onClick={() => setIsAddModalOpen(true)}>Create New User
                    </button>
                </div>
                <div className="overflow-x-auto">
                    <table className="min-w-full bg-white border border-gray-200 rounded-lg shadow-md">
                        <thead>
                            <tr className="text-left bg-gray-200 text-sm text-gray-600">
                                <th className="px-4 py-2">Name</th>
                                <th className="px-4 py-2">Email</th>
                                <th className="px-4 py-2">Role</th>
                                {/*<th className="px-4 py-2">Auth Method</th>*/}
                                <th className="px-4 py-2">Created At</th>
                                <th className="px-6 py-3">Delete</th>
                                <th className="px-4 py-2">Activate</th>
                                <th className="px-4 py-2">Suspend</th>
                                {/*<th className="px-4 py-2">Update Role</th>*/}
                            </tr>
                        </thead>
                        <tbody className="text-sm text-gray-600">
                            {filteredUsers.map((user, index) => (
                                <tr key={index} className="hover:bg-gray-100">
                                    <td className="px-4 py-2">{user.name}</td>
                                    <td className="px-4 py-2">{user.email}</td>
                                    <td className="px-4 py-2">{user.role}</td>
                                    {/*<td className="px-4 py-2">{user.auth_method}</td>*/}
                                    <td className="px-4 py-2">{new Date(user.created_at).toLocaleString()}</td>
                                    <td className="px-6 py-4">
                                        <button
                                            onClick={() => deleteUser(user.email)}
                                            className="text-red-500 hover:text-red-700"
                                        >
                                            Delete
                                        </button>
                                    </td>

                                    <td className="px-4 py-2">
                                        <button
                                            onClick={() => activateUser(user.email)}
                                            className={`${user.is_active ? "bg-gray-300 cursor-not-allowed" : "bg-yellow-500 hover:bg-yellow-600"
                                                } text-black px-4 py-2 rounded-md`}
                                            disabled={user.is_active}
                                        >
                                            Activate
                                        </button>
                                    </td>
                                    <td className="px-4 py-2">
                                        <button
                                            onClick={() => suspendUser(user.email)}
                                            className={`${user.is_active ? "bg-red-500 hover:bg-red-600" : "bg-gray-300 cursor-not-allowed"
                                                } text-white px-4 py-2 rounded-md`}
                                            disabled={!user.is_active}
                                        >
                                            Suspend
                                        </button>
                                    </td>
                                    {/*<td className="px-4 py-2">*/}
                                    {/*    <select*/}
                                    {/*        value={selectedRoles[user.email] || ""}*/}
                                    {/*        onChange={(e) => handleRoleChange(user.email, e.target.value)}*/}
                                    {/*        className="border border-gray-300 rounded-md px-2 py-1 focus:outline-none focus:ring-2 focus:ring-blue-500"*/}
                                    {/*    >*/}
                                    {/*        <option value="" disabled>Select User Role</option>*/}
                                    {/*        /!* Default placeholder option *!/*/}
                                    {/*        <option value="admin">Admin</option>*/}
                                    {/*        /!*<option value="teacher">Teacher</option>*!/*/}
                                    {/*        <option value="student">Student</option>*/}
                                    {/*    </select>*/}

                                    {/*    <button*/}
                                    {/*        onClick={() => updateUserRole(user.email, selectedRoles[user.email] || user.role)}*/}
                                    {/*        className="ml-2 bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md"*/}
                                    {/*    >*/}
                                    {/*        Update*/}
                                    {/*    </button>*/}
                                    {/*</td>*/}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                {/* Add Customer Modal */}
                {isAddModalOpen && (
                    <div className="modal-overlay" onClick={(e) => closeModal(e, setIsAddModalOpen)}>
                        <div className="modal-content" ref={modalRef}>
                            <button className="close-btn" onClick={() => setIsAddModalOpen(false)}><MdClose /></button>
                            <h2 className="modal-title">Add New Users</h2>
                            <form onSubmit={(e) => {
                                e.preventDefault();
                                createNewUser();
                            }} className="form-container">
                                <input type="text" name="name" placeholder="Name" value={newUserData.name}
                                    onChange={handleNewUserInputChange} required />
                                <input type="email" name="email" placeholder="Email" value={newUserData.email}
                                    onChange={handleNewUserInputChange} required />
                                <div className="password-field">
                                    <input type={passwordShown ? 'text' : 'password'} name="password"
                                        placeholder="Password" value={newUserData.password}
                                        onChange={handleNewUserInputChange} required />
                                    <i onClick={togglePasswordVisiblity} style={{
                                        position: 'absolute',
                                        right: '15px',
                                        top: '49%',
                                        transform: 'translateY(-50%)'
                                    }}>{passwordShown ? <FaEye /> : <FaEyeSlash />}</i>
                                </div>
                                <select name="role" value={newUserData.role || ""} onChange={handleNewUserInputChange}
                                    required>
                                    <option value="" disabled>Select User Role</option>
                                    <option value="admin">Admin</option>
                                    {/*<option value="teacher">Teacher</option>*/}
                                    <option value="student">Student</option>
                                </select>
                                <button type="submit" className="action-btn add-btn submit-btn">Add User</button>
                            </form>
                        </div>
                    </div>
                )}
            </div>

        </>
    );
}

export default UserView;
